import React, { useEffect, useState, useCallback, useRef } from "react";
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
import { DateTime } from "luxon";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import IconButton from "@mui/material/IconButton";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/styles";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { FilePicker } from "react-file-picker";

import cross from "../../components/profile/profileCompletion/images/cross.svg";

import "../RecruitmentPartnersAndClients/indexModal.css";

import { BlobServiceClient } from "@azure/storage-blob";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import getCustomerTypes from "../../apis/getCustomerType";
import Autocomplete from '@mui/material/Autocomplete';
import axios from "axios";
import organizationLogoUpdateResponse from "../../apis/organizationLogoUpload";
import ImageCropper from "./ImageCropper/ImageCropper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import DataTable from "../../components/DataTable/DataTable";
const styleSx = {
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: "16px",
    },
  },
  buttonAlign: {
    display: "flex",
    alignItems: "center",
    padding: "24px 42px 24px 42px !important",
  },
  bodyForEditProfile: {
    marginTop: "70px",
  },
  changeProfiletitle: {
    padding: "16px 42px!important",
  },
  changeprofilebody: {
    // Currently empty, add styles if needed
  },
};


/* ------------------------  */
// Styled DialogTitle root
const DialogTitleRoot = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: '16px',
  position: 'relative',
}));

// Styled DialogContent (default)
const DialogContent = styled(MuiDialogContent)(({ theme }) => ({}));

// Styled DialogContent for profile pic
const DialogContentForprofilepic = styled(MuiDialogContent)(({ theme }) => ({
  marginTop: '0px',
}));

// Styled DialogActions
const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: 0,
  padding: '16px',
}));

// DialogTitle component with close icon
const DialogTitleForProfilePic = ({ children, onClose, ...other }) => (
  <DialogTitleRoot disableTypography {...other}>
    <Typography variant="h6">{children}</Typography>
    {onClose ? (
      <div className="crossFormodal cp" onClick={onClose}>
        <img className="closeicon_set" src={cross} alt="" />
      </div>
    ) : null}
  </DialogTitleRoot>
);


const RecruitmentPartners = ({ openModal, setOpenModal }) => {
  const jsonConfig = require("../../Config.json");
  const [modalIsOpene, setmodalIsOpene] = useState(false);
  const [allData, setAllData] = useState([]);

  const isActiveItems = ["True", "False"];
  const [profilePictureEditModal, setProfilePictureEditModal] = useState(false);
  const userCameraStreamRef = useRef(null);

  const [display, setdisplay] = useState(false);
  const rotation = 0;
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [logoUrl, setlogoUrl] = useState();
  const [logoFilename, setlogoFilename] = useState(null);
  const [recruiterPartnerLogo, setrecruiterPartnerLogo] = useState(null);

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage2, setCroppedImage2] = useState(undefined);
  const getImgFreeCrop = (croppedImage2) => {
    setCroppedImage2(croppedImage2);
  };
  const [atvBtn, setAtvBtn] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [recruitmentPartnerInfo, setRecruitmentPartnerInfo] = useState({
    recName: "",
    status: "",
    recId: ""
  })
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]

  // //---------------------------------------

  const showCroppedImage = useCallback(
    async (recruiterID, recruiterName, newCroppedImg, logoFilename) => {
      try {
        const croppedImage = newCroppedImg;
        var block = croppedImage.split(";");

        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];
        await b64toBlob(
          realData,
          contentType,
          recruiterID,
          recruiterName,
          logoFilename
        );
        setdisplay(false);
      } catch (e) {
        console.error(e);
      }
    },
    [rotation]
  );

  const filePickerOnChange = async (file) => {
    const selectedFileName = file.name;
    setlogoFilename(selectedFileName);
    const downloadedUrl = URL.createObjectURL(file);
    setImageToCrop(downloadedUrl);
    setProfilePictureEditModal(true);
  };

  //------------ >  ON CROP MODAL SAVE BUTTON <------

  const logoSave = () => {
    setProfilePictureEditModal(false);
    setSelectedFileName(logoFilename);
    setImageToCrop("");
  };

  const logoRemove = () => {
    setSelectedFileName(null);
    setlogoFilename(null);
  };

  const closeProfilePicModal = async () => {
    setdisplay(false);
    setlogoFilename(null);

    if (userCameraStreamRef.current) {
      userCameraStreamRef.current.getTracks().forEach((track) => track.stop());
    }
    setProfilePictureEditModal(false);
  };

  const b64toBlob = async (
    b64Data,
    contentType,
    recruiterID,
    recruiterName,
    logoFilename,
    sliceSize
  ) => {

    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(
      byteArrays,
      { type: contentType },
      { name: "profile.png" }
    );
    await uploadToBlobStorage(blob, recruiterID, recruiterName, logoFilename);
  };

  //------------ Generating UUID -----------

  function create_UUID() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  //----------------------------------
  const clearData = () => {
    setRecruitmentPartnerInfo({
      recName: "",
      status: ""
    })
  };

  const handleisActive = (e, value) => {
    if (value === "True") {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, status: true })
    } else if (value === null) {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, status: undefined })
    } else {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, status: false })
    }
  };

  const handelEditClick = (value) => {
    setrecruiterPartnerLogo(value?.recruitmentpartnerLogoUrl);
    if (value?.isActive === true) {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, status: "true", recName: value.name.trim(), recId: value?.id })
    } else {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, status: "false", recName: value.name.trim() })
    }
    setmodalIsOpene((prev) => (prev = true));
  };

  const getUserID = localStorage.getItem("userID");

  // Create Recruitment Organization
  const createRecruiter = async () => {
    setAtvBtn(true)
    const jsonConfig = require("../../Config.json");
    var recData = {
      name: recruitmentPartnerInfo.recName?.trim(),
      isActive: recruitmentPartnerInfo.status,
      createdBy: getUserID,
      updatedBy: getUserID,
      recruitmentpartnerLogoUrl: logoFilename === null ? null : logoUrl,
    };
    if (
      recData.name === undefined ||
      recData.name === "" ||
      recData.isActive === undefined
    ) {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const recResponse = await axios.post(
          jsonConfig.apiUrl + "recruitmentpartner",
          recData,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        getData();
        if (
          recResponse.data.message ===
          "This recruitment partner name already exists Please use a different recruitment partner name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Recruitment organization name already exists. Please use a different Recruitment organization name.",
            "Error",
            10000
          );
        } else {

          NotificationManager.success(
            "Recruitment organization added successfully.",
            "Success",
            10000
          );
          setAtvBtn(false)
          var recruiterID = recResponse.data.data.id;
          showCroppedImage(recruiterID, recruitmentPartnerInfo.recName, croppedImage2, logoFilename);
          setOpenModal(false);
          clearData();
        }
      } catch (error) {
        console.log(error);
        setAtvBtn(false)
        getData();
      }
    }
  };

  const uploadToBlobStorage = async (
    blob,
    recruiterID,
    recruiterName,
    logoFilename
  ) => {
    const sas = jsonConfig.sasToken;
    const uuid = create_UUID();
    const bsClient = new BlobServiceClient(
      `${jsonConfig.ctResourcesCdn + sas}`
    );
    const containerClient = bsClient.getContainerClient("organizationlogos");
    const recruitmentPartnerName = recruiterName
      .replace(/ /g, "")
      .toLowerCase();
    const blobName =
      recruiterID + "/" + uuid + "_" + recruitmentPartnerName + ".png";

    const url = `${jsonConfig.ctResourcesCdn}/organizationlogos/${blobName}`;
    setlogoUrl(url);

    const blobClient = containerClient.getBlockBlobClient(blobName);
    if (logoFilename === null) {
    } else {
      await blobClient.uploadBrowserData(blob);
    }
    var dt = new Date();
    if (logoFilename === null) {
    } else {
      var orgImagedata = {
        id: recruiterID,
        recruitmentpartnerLogoUrl: url,
        lastUpdated: dt,
      };
    }

    try {
      const payload = {
        userId: recruiterID,
        orgImagedata: orgImagedata,
      };
      await organizationLogoUpdateResponse(payload);
      setProfilePictureEditModal(false);
      setSelectedFileName(null);
      getData();
    } catch (error) {
      console.error(error);
    }
  };

  // Edit Recruitment Organization
  const editRecruiter = async () => {
    setAtvBtn(true)
    let recrData = {
      name: recruitmentPartnerInfo.recName?.trim(),
      updatedBy: getUserID,
      isActive: recruitmentPartnerInfo.status,
      recruitmentpartnerLogoUrl: logoFilename === null ? null : logoUrl,
    };

    let Id = recruitmentPartnerInfo.recId;

    if (recrData.name === undefined || recrData.name === "") {
      setAtvBtn(false)
      return NotificationManager.error(
        "Please fill all the mandatory fields.",
        "Error",
        10000
      );
    } else {
      try {
        const custResponse = await axios.put(
          jsonConfig.apiUrl + "recruitmentpartner/" + Id,
          recrData,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        getData();

        if (
          custResponse.data.message ===
          "This Recruitment organization name already exists Please use a different Recruitment organization name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Recruitment organization name already exists. Please use a different Recruitment organization name.",
            "Error",
            10000
          );
        } else {
          NotificationManager.success(
            "Recruitment organization updated successfully.",
            "Success",
            10000
          );
          showCroppedImage(Id, recruitmentPartnerInfo.recName, croppedImage2, logoFilename);
          handleClosed();
          clearData();
          setAtvBtn(false)
        }
      } catch (error) {
        console.log(error);
        setAtvBtn(false)
      }
    }
  };

  const handleName = (e) => {
    if (e.target.value) {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, recName: e.target.value.trim() })
    } else {
      setRecruitmentPartnerInfo({ ...recruitmentPartnerInfo, recName: "" })
    }
  };

  const getData = async () => {
    setIsDataLoaded(false);
    let data = await getAllRecruitmentPartnersAndClients();
    await getCustomerTypes();
    let allDataSet = data?.data?.data;

    for (let i = 0; i < allDataSet.length; i++) {
      let a = allDataSet[i]?.recruitmentpartnercustomers;
      let b = a.map((item) => item?.customer?.name).join();
      allDataSet[i].customersName = b;

      let agencies = allDataSet[i]?.agencies;
      let agencyNam = agencies.map((item) => item?.agencyName).join(", ");
      allDataSet[i].agenciesName = agencyNam;

      let date = allDataSet[i]?.createdAt;
      let convertedDate = DateTime.fromISO(date)
        .toLocal()
        .startOf("day")
        .toJSDate();
      allDataSet[i].createdTime = convertedDate;
    }
    setAllData(allDataSet);
    setIsDataLoaded(true);
  };

  const handleClosed = () => {
    setmodalIsOpene((prev) => (prev = false));
    setlogoFilename(null);
    setSelectedFileName(null);
  };


  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.createdAt;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }

  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  const columns = [
    {
      accessorKey: 'Action',
      header: 'Action',
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <Button
          onClick={(e) =>
            handelEditClick(row.original)
          }
          variant="contained"
          color="primary"
        >
          Edit
        </Button>
      ),
      size: 120,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      size: 250,
      enableColumnFilter: true,
      enableSorting: true,
    },
    {
      accessorKey: 'customersName',
      header: 'Customers',
      size: 250,
      enableColumnFilter: true,
      enableSorting: true,
    },
    {
      accessorKey: 'agenciesName',
      header: 'Agencies',
      size: 250,
      enableColumnFilter: true,
      enableSorting: true,
    },
    {
      accessorKey: 'createdTime',
      header: 'Created At',
      size: 250,
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.createdAt)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 100,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]

  useEffect(() => {
    setlogoFilename(null);
    setSelectedFileName("");
  }, [openModal, logoFilename, selectedFileName]);

  useEffect(() => {
    setlogoFilename(null);
    getData();
  }, []);

  return (
    <>
      <div className="containerMain_recPartnersAndClients">
        <DataTable
          columns={columns}
          data={allData}
          isLoading={!isDataLoaded}
          className="table_recPartnersAndClients"
          initialColumnFilters={[
            {
              id: 'isActive',
              value: 'true'
            }
          ]}
        />
      </div>

      {/* add */}
      <Dialog
        onClose={() => setOpenModal(false)}
        aria-labelledby="customized-dialog-title"
        open={openModal}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle className="admindailog_title_modal_recruitmentpartners">
            Add Recruitment Organization
            <IconButton
              aria-label="close"
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                color: "grey",
              }}
              onClick={() => setOpenModal(false)}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Recruitment Organization Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Recruitment Organization Name"
              className="admin_textbox"
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
          <Typography>Organization Logo (Optional)</Typography>
          <FormControl fullWidth variant="outlined">
            <div id="orgLogoUploadContainer">
              <label htmlFor="contained-button-file">
                <FilePicker
                  extensions={["jpg", "jpeg", "png"]}
                  onChange={filePickerOnChange}
                  onError={(errMsg) => {
                    NotificationManager.error(errMsg, "Error");
                  }}
                >
                  {/*--------- Upload Organization Button------------ */}
                  <button className="logoButton_rp">
                    <CloudUploadIcon />{" "}
                    <span className="logoButton_rp_text">Upload Logo</span>
                  </button>
                </FilePicker>
              </label>
              <Typography variant="subtitle2" component="h2">
                {selectedFileName ? (
                  <div sx={styleSx.root}>
                    <Alert
                      id="orglogoFileName"
                      onClose={logoRemove}
                      closeText="Remove"
                    >
                      {selectedFileName}
                    </Alert>
                  </div>
                ) : (
                  ""
                )}
              </Typography>
            </div>
          </FormControl>
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>
            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={createRecruiter}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
        <Dialog
          id="mainContainer"
          open={profilePictureEditModal}
          onClose={closeProfilePicModal}
          aria-labelledby="customized-dialog-title"
          maxWidth="sm"
          fullWidth={true}
          className="record-video-intro-responsive"
        >
          <DialogTitleForProfilePic
            className="responsive-profilepic_title" sx={styleSx.changeProfiletitle}
            onClose={closeProfilePicModal}
          >
            Organization Logo
          </DialogTitleForProfilePic>

          <DialogContentForprofilepic
            className="responsive-profilepic_body" sx={styleSx.changeprofilebody}
          >
            {display ? null : (
              <div className="text-center">
                <div className="crop-container" id="rectCrop">
                  <div id="freeCropper">
                    <ImageCropper
                      id="freeCropper"
                      imageToCrop={imageToCrop}
                      onImageCropped={(croppedImage2) =>
                        getImgFreeCrop(croppedImage2)
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </DialogContentForprofilepic>
          {display ? null : (
            <>
              <div className="divider_adjust">
                <hr className="new3 mt_20 mb_0" />
              </div>
              <DialogActions
                className="responsive-dialog" sx={styleSx.buttonAlign}
              >
                <button
                  type="button"
                  className="btn-big btn-green ml_5 cp "
                  // onClick={showCroppedImage} // <--------- LOGO UPLOAD TRIGGER
                  onClick={logoSave}
                >
                  Save Logo
                </button>
                <button
                  type="button"
                  className="btn-big btn-skill cp "
                  onClick={closeProfilePicModal}
                >
                  Cancel
                </button>
              </DialogActions>
            </>
          )}
        </Dialog>
        <NotificationContainer />
      </Dialog>
      {/* Edit */}
      <Dialog
        onClose={handleClosed}
        aria-labelledby="customized-dialog-title"
        open={modalIsOpene}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle className="admindailog_title_modal_recruitmentpartners">
            Edit Recruitment Organization
            <IconButton
              aria-label="close"
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                color: "grey",
              }}
              onClick={handleClosed}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>

        <DialogContent>
          <Typography gutterBottom>Recruitment Organization Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              placeholder="Enter Recruitment Organization Name"
              className="admin_textbox"
              defaultValue={recruitmentPartnerInfo.recName}
              onChange={handleName}
            />
          </FormControl>
          &nbsp;
          <Typography>Is Active*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              options={isActiveItems}
              disabled
              defaultValue={recruitmentPartnerInfo.status === "true" ? "True" : "False"}
              getOptionLabel={(option) => option}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Status"
                />
              )}
              onChange={handleisActive}
            />
          </FormControl>
          &nbsp;
          <Typography>Organization Logo (Optional)</Typography>
          <FormControl fullWidth variant="outlined">
            <div id="orgLogoUploadContainer">
              <label htmlFor="contained-button-file">
                <FilePicker
                  extensions={["jpg", "jpeg", "png"]}
                  onChange={filePickerOnChange}
                  onError={(errMsg) => {
                    NotificationManager.error(errMsg, "Error");
                  }}
                >
                  <button className="logoButton_rp">
                    <CloudUploadIcon />{" "}
                    <span className="logoButton_text"></span>
                    {selectedFileName === null && recruiterPartnerLogo ? (
                      <div className="logoButton_rp_text">Change Logo</div>
                    ) : (
                      <div className="logoButton_rp_text">Upload Logo</div>
                    )}
                  </button>
                </FilePicker>
              </label>
              {selectedFileName === null && recruiterPartnerLogo ? (
                <div>
                  <img
                    className="recruiterLogoContainer"
                    id="editRecruiterLogoContainer"
                    src={recruiterPartnerLogo}
                    alt=""
                  />
                </div>
              ) : (
                <Typography variant="subtitle2" component="h2">
                  {selectedFileName ? (
                    <div sx={styleSx.root}>
                      <Alert
                        id="orglogoFileName"
                        onClose={logoRemove}
                        closeText="Remove"
                      >
                        {selectedFileName}
                      </Alert>
                    </div>
                  ) : (
                    ""
                  )}
                </Typography>
              )}
            </div>
          </FormControl>
        </DialogContent>

        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={handleClosed}>
              Cancel
            </Button>

            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={editRecruiter}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
        <Dialog
          id="mainContainer"
          open={profilePictureEditModal}
          onClose={closeProfilePicModal}
          aria-labelledby="customized-dialog-title"
          maxWidth="sm"
          fullWidth={true}
          className="record-video-intro-responsive"
        >
          <DialogTitleForProfilePic
            className="responsive-profilepic_title" sx={styleSx.changeProfiletitle}
            onClose={closeProfilePicModal}
          >
            Organization Logo
          </DialogTitleForProfilePic>

          <DialogContentForprofilepic
            className="responsive-profilepic_body" sx={styleSx.changeprofilebody}
          >
            {display ? null : (
              <div
                className="text-center"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <div className="crop-container" id="rectCrop">
                  <div id="freeCropper">
                    <ImageCropper
                      id="freeCropper"
                      imageToCrop={imageToCrop}
                      onImageCropped={(croppedImage2) =>
                        getImgFreeCrop(croppedImage2)
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </DialogContentForprofilepic>
          {display ? null : (
            <>
              <div className="divider_adjust">
                <hr className="new3 mt_20 mb_0" />
              </div>
              <DialogActions
                className="responsive-dialog" sx={styleSx.buttonAlign}
              >
                <button
                  type="button"
                  className="btn-big btn-green ml_5 cp "
                  onClick={logoSave}
                >
                  Save Logo
                </button>
                <button
                  type="button"
                  className="btn-big btn-skill cp "
                  onClick={closeProfilePicModal}
                >
                  Cancel
                </button>
              </DialogActions>
            </>
          )}
        </Dialog>
        <NotificationContainer />
      </Dialog>
    </>
  );
};

export default RecruitmentPartners;

